// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-mass-times-MassTimesView__hoursContainer--DINEY{margin-top:5rem}.src-components-mass-times-MassTimesView__removeBtnStyles--DDIrK{cursor:pointer;appearance:none;background:unset;border:unset;padding:unset}`, "",{"version":3,"sources":["webpack://./src/components/mass-times/MassTimesView.scss"],"names":[],"mappings":"AACA,gEACI,eAAA,CAGJ,iEACI,cAAA,CACA,eAAA,CACA,gBAAA,CACA,YAAA,CACA,aAAA","sourcesContent":["@import 'variables';\n.hoursContainer {\n    margin-top: 5rem;\n}\n\n.removeBtnStyles {\n    cursor: pointer;\n    appearance: none;\n    background: unset;\n    border: unset;\n    padding: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": `#ec9300`,
	"secondary": `#00a5aa`,
	"secondaryDark": `#264550`,
	"backgroundBlue": `#eaf6f7`,
	"hoursContainer": `src-components-mass-times-MassTimesView__hoursContainer--DINEY`,
	"removeBtnStyles": `src-components-mass-times-MassTimesView__removeBtnStyles--DDIrK`
};
export default ___CSS_LOADER_EXPORT___;
